import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export interface AgentProviderProps {
  children: React.ReactNode;
  queryClient?: QueryClient;
}

// Create default query client with optimized settings for agent operations
const createDefaultQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: 'always'
    },
    mutations: {
      retry: 1,
      // Global error handling for mutations
      onError: (error: any) => {
        console.error('Mutation error:', error);
      }
    }
  }
});

export const AgentProvider: React.FC<AgentProviderProps> = ({
  children,
  queryClient = createDefaultQueryClient()
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};